import { SWReactIcons } from "@similarweb/icons";
import { translate } from "app/filters/i18nFilter";
import { swNumberFilter } from "app/filters/ngFilters";
import { memo } from "react";
import { StyledContainer, StyledIconContainer, StyledLabel, StyledNumberText } from "./styles";

type SelectionDropdownFooterProps = {
    label?: string;
    numberOfRemainingItems: number;
};

function formatLargeNumber(value: number) {
    if (typeof value === "undefined") {
        return "";
    }

    if (value <= 0) {
        return String(0);
    }

    return swNumberFilter()(value);
}

const SelectionDropdownFooter = (props: SelectionDropdownFooterProps) => {
    const { label = translate("si.common.remaining"), numberOfRemainingItems } = props;

    return (
        <StyledContainer data-automation="table-actions-panel.selection-dropdown-footer">
            <StyledIconContainer>
                <SWReactIcons iconName="info-full-gradient" />
            </StyledIconContainer>
            <StyledLabel data-automation="selection-dropdown-footer.label">{label}&nbsp;</StyledLabel>
            <StyledNumberText data-automation="selection-dropdown-footer.value">
                {formatLargeNumber(numberOfRemainingItems)}
            </StyledNumberText>
        </StyledContainer>
    );
}

export default memo(SelectionDropdownFooter);
